<template>
  <div class="animated fadeIn">
    <br />
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Cambio ECC EAC</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Cambio ECC EAC</strong>
          </div>
          <b-row>
            <b-col sm="6">
              <b-button 
                variant="primary" 
                @click="modalCargarExcel = true"
                >Cargar Excel</b-button
              >
              <b-button
                variant="primary"
                @click="agregar"
                style="margin-left: 10px"
                >Ingreso Manual</b-button
              >
              <b-button
                variant="success"
                @click="generar_cartas"
                style="margin-left: 10px"
                >Generar Cartas</b-button
              >
              <b-button
                variant="warning"
                @click="pre_insertar"
                style="margin-left: 10px"
                >Limpiar</b-button
              >
            </b-col>

            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{
                    background: true,
                    pageSizes: [10, 20, 50],
                  }"
                  layout="table"
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>

                  <el-table-column label="" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="button.handler"
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.id"
                      >
                        {{ button.name }}
                      </el-button>
                    </template>
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- agregar poliza -->

    


    <b-modal
      title="Incluir Cambios"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalNuevo"
      @ok="agregarGuardar"
      @cancel="modalNuevo = false"
    >
      
      <b-row class="my-1">
        <b-col sm="4">
          <label>Póliza</label>
        </b-col>
        <b-col sm="8">
           <b-form-group> 
          <b-input-group> 
              <b-form-input 
                  type="text" 
                  v-model="datosFormulario.poliza"
                  @change="consulta_poliza(), validarCampo('pkg_compp_mailcartas', 'poliza', $event, 'datosFormulario')"
                  :disabled="campoBloqueado('poliza', 'datosFormulario')"
                  >
              </b-form-input>
              <b-input-group-prepend class="input-group-append">
                  <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
              </b-input-group-prepend>
          </b-input-group>
          <span class="error-validacion-campo">
              {{ mensajeValidacionCampo.poliza }}
          </span>     
           </b-form-group> 
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>ECC</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <b-form-select 
                  :options="ejecutivos" 
                  v-model="datosFormulario.ecc_nuevo"
                  @change="validarCampo('pkg_compp_mailcartas', 'ecc_nuevo', $event, 'datosFormulario')"
                  :disabled="campoBloqueado('ecc_nuevo', 'datosFormulario')">
            </b-form-select>
            <span class="error-validacion-campo">
              {{ mensajeValidacionCampo.ecc_nuevo }}
            </span>   
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>EAC / ACC</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <b-form-select 
                  :options="asistentes" 
                  v-model="datosFormulario.eac_nuevo"
                  @change="validarCampo('pkg_compp_mailcartas', 'eac_nuevo', $event, 'datosFormulario')"
                  :disabled="campoBloqueado('eac_nuevo', 'datosFormulario')">
            </b-form-select>
            <span class="error-validacion-campo">
              {{ mensajeValidacionCampo.eac_nuevo }}
            </span>   
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Motivo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <b-form-select 
                  :options="motivos" 
                  v-model="datosFormulario.codigomotivo"
                  @change="validarCampo('pkg_compp_mailcartas', 'codigomotivo', $event, 'datosFormulario')"
                  :disabled="campoBloqueado('codigomotivo', 'datosFormulario')">
            </b-form-select>
            <span class="error-validacion-campo">
              {{ mensajeValidacionCampo.codigomotivo }}
            </span>   
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Correo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <b-form-select 
                  :options="correotodas" 
                  v-model="datosFormulario.correo_todas"
                  @change="validarCampo('pkg_compp_mailcartas', 'correo_todas', $event, 'datosFormulario')"
                  :disabled="campoBloqueado('correo_todas', 'datosFormulario')">
            </b-form-select>
            <span class="error-validacion-campo">
              {{ mensajeValidacionCampo.correo_todas }}
            </span>   
          </b-form-group>
        </b-col>
      </b-row>

    </b-modal>

    <b-modal
     title="Correo por Póliza?"
     ok-title="Si"
     cancel-title="No"
     class="modal-success"
     v-model="modalCorreo"
     @ok = "todasPolizas('TP')"
     @cancel="todasPolizas('XP')"
     >

     ¿El contratante <b>{{this.datosFormulario.contratante}}</b> registra mas de una póliza vigente. Necesita generar 1 mail,
     incluyendo todas las Pólizas? <br/> 
     <b>SI - NO</b>
    </b-modal>

    <!-- Eliminar -->
    <b-modal
      title="Eliminar Póliza"
      cancel-title="Cancelar"
      ok-title="Eliminar"
      class="modal-success"
      v-model="modalEliminar"
      @ok="eliminarGuardar()"
      @cancel="modalEliminar = false"
    >
      Se eliminara la siguiente póliza:
      <br /><br />
      Póliza: {{ datosFormulario.poliza }}
      <br />
      Contratante: {{ datosFormulario.contratante }}
    </b-modal>

    <!-- carga excel -->
    <b-modal v-model="modalCargarExcel" 
        size="l" 
        @cancel="modalCargarExcel = false" 
        @ok="submitUpload"
        cancel-title="Cancelar" 
        ok-title="Cargar">
        <div slot="modal-header">
            <strong>Cargar Excel</strong>
        </div>
        <b-row>
            <b-col>
                <b-form id="frmFile">
                    <input type="file" 
                        @change="onFileChange">
                </b-form>
                    <span class="error-validacion-campo">
                       {{ mensajeValidacionInicialExcel }}
                    </span>
            </b-col>
        </b-row>
        <b-row>
          <b-col>
          <b-button variant="link" @click="download_plantilla">Descargar Formato</b-button>
          </b-col>
        </b-row>
    </b-modal>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiMailCartas from "@/components/services/apiMailCartas";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";
import { number } from "yargs";

var state = {
  tickets: [{ name: "test" }],
  headers: ["Test header"]
};

export default {
  name: "cambioecceac",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      archivo: state,
      porinsertar: 0,
      cargafinalizada: true,
      errores: "",
      showModalErrores: false,
      showDismissibleAlert: false,

      modalEliminar: false,
      modalNuevo: false,
      modalCargarExcel: false,
      modalCorreo: false,
      hasPoliza: false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },

      data: [],
      nombreexcel: "plantilla-cambioecceac.xls",
      titles: [
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "codigo",
          label: "Código",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "contratante",
          label: "Contratante",
          align: "left",
          minwidth: "200",
        },
        {
          prop: "ecc_actual",
          label: "ECC Actual",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "eac_actual",
          label: "EAC Actual",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "ecc_nuevo",
          label: "ECC Nuevo",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "eac_nuevo",
          label: "EAC Nuevo",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "codigomotivo",
          label: "Código Motivo",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "motivo",
          label: "Motivo de Cambio",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "correo_todas",
          label: "Código Correo",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "correotodas",
          label: "Descripción",
          align: "center",
          minwidth: "150",
        },
      ],
      filters: [
        {
          value: "",
          filterFn: (row, filter) => {
            return Object.keys(row).some((prop) => {
              if (prop === "desde") {
                let elDate = new Date(row["desde"]);
                let newdate = moment(elDate)
                  .add(1, "days")
                  .format("DD/MM/YYYY");
                return newdate.indexOf(filter.value) > -1;
              } else if (prop === "hasta") {
                let elDate = new Date(row["hasta"]);
                let newdate = moment(elDate)
                  .add(1, "days")
                  .format("DD/MM/YYYY");
                return newdate.indexOf(filter.value) > -1;
              } else {
                return (
                  row[prop]
                    .toString()
                    .toLowerCase()
                    .indexOf(filter.value.toLowerCase()) > -1
                );
              }
              return (
                row[prop]
                  .toString()
                  .toLowerCase()
                  .indexOf(filter.value.toLowerCase()) > -1
              );
            });
          },
        },
      ],

      datosFormulario: {
        poliza: "",
        codigo: "",
        contratante: "",
        ecc_nuevo: "",
        eac_nuevo: "",
        ecc_actual: "",
        eac_actual: "",
        codigomotivo: "",
        motivo: "",
        srCantPoli: 0,
        correo_todas:"",
      },
      motivos: [],
      ejecutivos: [],
      asistentes: [],
      correotodas:[],

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      mensajeValidacionInicialExcel: "",

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "poliza",
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {
    customButtonsForRow(row) {
      var botones = new Array();

      var obj = new Object();
      obj.tooltip = "Eliminar";
      obj.id = 1;
      obj.name = "Eliminar";
      obj.icon = "fa fa-eraser";
      obj.type = "success";
      obj.handler = (_) => {
        this.$session.start();
        this.eliminar(row);
      };
      botones.push(obj);

      return botones;
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    cambiarFechas() {
      if (this.datosFormulario.selected == "A") {
        this.mostrarFechas = false;
      } else {
        this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      n = String(n).replace(/\D/g, "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
          /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    exportarExcel() {
      this.$nextTick(function () {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },

    llenaArrayLista(data, valor, texto, isDate) {
      var arr = new Array();
      for (var i = 0; i < data.length; i++) {
        var obj = new Object();
        if (isDate) {
          obj.value = this.convierteFecha(data[i][valor]);
          obj.text = this.convierteFecha(data[i][texto]);
        } else {
          obj.value = data[i][valor].toString();
          obj.text = data[i][texto];
        }
        arr.push(obj);
      }
      return arr;
    },

    pre_insertar() {
      this.$Progress.start();
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.motivos = [];
      this.ejecutivos = [];
      this.asistentes = [];
      this.correotodas= [];
      this.value = null;

      this.datosFormulario.poliza = "";
      this.datosFormulario.contratante = "";
      this.datosFormulario.ecc = "";
      this.datosFormulario.eac = "";
      this.datosFormulario.motivo = "";
      this.datosFormulario.correo_todas="";

      return apiMailCartas
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          this.datosFormularioEstado = response.data.festado;

          //carga de listados
          this.motivos = this.llenaArrayLista(
            response.data.motivos,
            "codigo",
            "descripcion",
            false
          );
          this.asistentes = this.llenaArrayLista(
            response.data.asistentes,
            "usucodigo",
            "usucodigo",
            false
          );
          this.ejecutivos = this.llenaArrayLista(
            response.data.ejecutivos,
            "usucodigo",
            "usucodigo",
            false
          );
          this.correotodas = this.llenaArrayLista(
            response.data.correo_poliza,
            "codigo",
            "descripcion",
            false
          );

          this.$Progress.finish();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();

      return apiAtradius
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.data = response.data.res;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.$Progress.finish();
          this.mensaje = error;
          this.variant = "danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if (
        (column.property == "desde" || column.property == "hasta") &&
        row[column.property]
      ) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      } else if (column.property == "MONTOFINIQUITO" && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Mantenedor Polizas Atradius</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";

      //Data bloque 1
      for (var key in this.data) {
        cuerpo +=
          "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["poliza"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["contratante"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["producto"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["ejecutivo"] +
          "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "'>" +
          this.data[key]["asistente"] +
          "</td>\n";
        //cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["desde"] + "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "mso-number-format:\"@\"''  >" +
          this.convierteFecha(this.data[key]["desde"]) +
          "</td>\n";
        //cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["hasta"] + "</td>\n";
        cuerpo +=
          "<td class=xl649618 style='border-top:none;border-left:none;" +
          xl649618 +
          "mso-number-format:\"@\"''  >" +
          this.convierteFecha(this.data[key]["hasta"]) +
          "</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

    consulta_poliza: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;
      
      var p_email= this.$session.get("mail");
      var p_poliza = this.datosFormulario.poliza;

      return apiMailCartas
        .consultaPoliza(
          p_email, p_poliza
        ).then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {

            this.datosFormulario.codigo       = Listapoliza[i]["sr"];
            this.datosFormulario.contratante  = Listapoliza[i]["contratante"];
            this.datosFormulario.srCantPoli  = Listapoliza[i]["cantpolizas"];
            this.datosFormulario.ecc_actual   = Listapoliza[i]["ejecutivo"];
            this.datosFormulario.eac_actual   = Listapoliza[i]["asistente"];
            this.datosFormulario.ecc_nuevo   = Listapoliza[i]["ejecutivo"];
            this.datosFormulario.eac_nuevo   = Listapoliza[i]["asistente"];
            this.datosFormulario.correo_todas= "TP";
            
            ///MODAL CORREO
            if (this.datosFormulario.srCantPoli>1){
              this.modalCorreo = true;
            }

            this.hasPoliza = true;
          }
          this.$Progress.finish(); 
        })
        .catch((error) => {
          this.$Progress.finish();
          this.crearNotificacion(
              "Atención",
              error,
              "error"
            );
        });
    },

    agregar: function () {
      this.mensajeValidacionCampo = {};
      this.datosFormulario.poliza = "";
      this.datosFormulario.codigo = "";
      this.datosFormulario.contratante = "";
      this.datosFormulario.ecc_nuevo = "";
      this.datosFormulario.eac_nuevo = "";
      this.datosFormulario.ecc_actual = "";
      this.datosFormulario.eac_actual = "";
      this.datosFormulario.motivo = "";
      this.datosFormulario.codigomotivo = "";
      this.datosFormulario.correo_todas="";
      this.hasPoliza = false;
      this.modalNuevo = true;
    },

    agregarGuardar(event) {
      event.preventDefault(); 
      return apiMailCartas
        .insertar(
          this.$session.get("mail"),
          this.datosFormulario.poliza,
          this.datosFormulario.ecc_nuevo,
          this.datosFormulario.eac_nuevo,
          this.datosFormulario.codigomotivo
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          if (response.data.festado.resultado.estado == "error"){
            this.mostrarErroresEnFormulario(response.data.festado);
          }
          else{
            
            if (!this.validarpoliza(this.datosFormulario.poliza)){
              var obj = new Object();
              obj.poliza = this.datosFormulario.poliza;
              obj.codigo = this.datosFormulario.codigo;
              obj.contratante = this.datosFormulario.contratante;
              obj.ecc_nuevo = this.datosFormulario.ecc_nuevo;
              obj.eac_nuevo = this.datosFormulario.eac_nuevo;
              obj.ecc_actual = this.datosFormulario.ecc_actual;
              obj.eac_actual = this.datosFormulario.eac_actual;
              obj.codigomotivo = this.datosFormulario.codigomotivo;
              obj.srCantPoli = this.datosFormulario.srCantPoli;

             
              for (let i = 0; i < this.motivos.length; i++) {
                  if (this.motivos[i]["value"] == this.datosFormulario.codigomotivo){
                    obj.motivo = this.motivos[i]["text"];
                  }
              }

              for (let j = 0; j < this.correotodas.length; j++) {
                  if (this.correotodas[j]["value"] == this.datosFormulario.correo_todas){
                    obj.correo_todas = this.datosFormulario.correo_todas;
                    obj.correotodas = this.correotodas[j]["text"];
                  }
              }
              this.data.push(obj);
              this.modalNuevo = false;
            }else{
              this.crearNotificacion(
                "Atención",
                "Esta póliza ya esta ingresada.",
                "error"
              );
            }
          }

        });
      
    },

    validarSR(codsr, poliza ,correo){
    for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].codigo == codsr && this.data.poliza == poliza && this.data[i].correo_todas == correo){
            return true;
          }
      }
      return false;
    },
    
    validarpoliza(poliza){
      for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].poliza == poliza){
            return true;
          }
      }
      return false;
    },

    eliminar(row) {
      this.datosFormulario.poliza = row.poliza;
      this.datosFormulario.contratante = row.contratante;
      this.modalEliminar = true;
    },
    todasPolizas(valor){
     console.log("todasPolizas" ,valor);
     this.datosFormulario.correo_todas= valor;
     this.modalCorreo=false;
    },
    eliminarGuardar() {
      var posicion = 0;
      for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].poliza == this.datosFormulario.poliza){
            posicion = i;
          }
      }
      this.data.splice(posicion, 1);
      this.crearNotificacion(
          "Atención",
          "Eliminado con éxito.",
          "success"
        );
    },

    submitUpload: async function() {
      this.$Progress.start();
      var excel = [];
      excel = this.archivo.tickets;
      
      var repetidas = 0;
      var cont = 0;
      
      for (var i = 0; i < excel.length; i++) {
        
        if (excel[i][0] != "" && excel[i][0] != undefined){
          //console.log(excel[i]);

          if (excel[i].length<4){
            this.$Progress.finish();
            this.crearNotificacion("Atención", "Error de formato, por favor cargar nuevamente", "error");
            return false;
          }
          
          var obj = new Object();
          obj.poliza = excel[i][0];
          obj.codigo = "";
          obj.contratante = "";
          obj.ecc_nuevo = excel[i][1];
          obj.eac_nuevo = excel[i][2];
          obj.ecc_actual = "";
          obj.eac_actual = "";
          obj.codigomotivo = excel[i][3];
          if (excel[i][4]==undefined){
          obj.correo_todas= "TP";
          }
          else{
            obj.correo_todas = excel[i][4];
          }
          
          for (let i = 0; i < this.motivos.length; i++) {
              if (this.motivos[i]["value"] == obj.codigomotivo){
                obj.motivo = this.motivos[i]["text"];
              }
          }

          for (let i = 0; i < this.correotodas.length; i++) {
              if (this.correotodas[i]["value"] == obj.correo_todas){
                obj.correotodas = this.correotodas[i]["text"];
              }
          }

          await apiMailCartas.consultaPoliza(this.$session.get("mail"), obj.poliza).then((response) => {
            response.data = this.keysMinuscula(response.data);
            
            var Listapoliza = response.data.res;
            for (var i = 0; i < Listapoliza.length; i++) {
              obj.codigo       = Listapoliza[i]["sr"];
              obj.contratante  = Listapoliza[i]["contratante"];
              obj.ecc_actual   = Listapoliza[i]["ejecutivo"];
              obj.eac_actual   = Listapoliza[i]["asistente"];
            }

           // console.log(obj.ecc_nuevo)
            // obj.eac_nuevo===undefined? obj.eac_actual : obj.eac_nuevo;
            // obj.ecc_nuevo===undefined? obj.ecc_actual : obj.ecc_nuevo;

            if ((obj.ecc_nuevo==undefined)){ obj.ecc_nuevo=obj.ecc_actual; }
            if ((obj.eac_nuevo==undefined)){ obj.eac_nuevo= obj.eac_actual;  }
          })
          .catch((error) => {
            this.$Progress.finish();
            this.crearNotificacion("Atención", error, "error");
          });

          if(!this.validarSR(obj.codigo, obj.poliza, obj.correo_todas)){
            this.data.push(obj);
          }
          else{
            if (!this.errores.toString().includes(obj.codigo)){
            this.errores += obj.codigo + " "+  obj.contratante + ", ";
            }
            repetidas = repetidas +1;
          }

          // if (!this.validarpoliza(obj.poliza)){
          //   this.data.push(obj);
          // }else{
          //   this.errores += obj.poliza + ",";
          //   repetidas = repetidas + 1;
          // }
          cont += 1;
        }
      } 
      this.$Progress.finish();
      
      
      if (this.errores == ""){
        this.crearNotificacion("Atención", "Se cargaron " + cont + " registros. ", "success");
      }else{
        this.crearNotificacion("Atención", "Se cargaron " + (cont - repetidas) + " registros. ", "success");
        this.crearNotificacion("Atención", "El SR " + this.errores + " ya existe en la lista. ", "error");
        this.errores = "";
      }
    },

    onFileChange: function onFileChange(e) {
      let _this = this;

      var files = e.target.files || e.dataTransfer.files;

      var i = 0;
      var f = "";

      for (i = 0, f = files[i]; i != files.length; ++i) {
        var reader = new FileReader(),
          name = f.name;

        reader.onload = function(e) {
          data = e.target.result;

          var o = "";
          var l = 0;
          var w = 10240;

          for (; l < data.byteLength / w; ++l)
            o += String.fromCharCode.apply(
              null,
              new Uint8Array(data.slice(l * w, l * w + w))
            );
          o += String.fromCharCode.apply(
            null,
            new Uint8Array(data.slice(l * w))
          );

          var results;
          var data = e.target.result;
          var fixedData = o; //fixdata(data),

          try {
            var workbook = XLSX.read(btoa(fixedData), { type: "base64" });
          } catch (error) {
            if (_this.mensajeValidacionCampo.cargar == undefined)
              _this.$set(
                _this.mensajeValidacionCampo,
                "cargar",
                "Excel con formato errado"
              );
            else
              _this.mensajeValidacionCampo.cargar = "Excel con formato errado";
          }

          var firstSheetName = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[firstSheetName];

          var headers = [],
            range = XLSX.utils.decode_range(worksheet["!ref"]);
          var C,
            R = range.s.r; /* start in the first row */
          for (C = range.s.c; C <= range.e.c; ++C) {
            /* walk every column in the range */
            var cell =
              worksheet[
                XLSX.utils.encode_cell({ c: C, r: R })
              ]; /* find the cell in the first row */
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default
            if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            headers.push(hdr);
          }

          state.headers = headers;

          results = XLSX.utils.sheet_to_json(worksheet);

          var cols = state.headers;

          var list = new Array();

          for (var i = 0; i < results.length; i++) {
            var a = [];

            for (var j = 0; j < cols.length; j++) {
              a[j] = results[i][cols[j]];
            }

            list.push(a);
          }

          //state.tickets=results;
          state.tickets = list;
          this.archivo = state;
        };

        reader.readAsArrayBuffer(f);
      }
    },

    download_plantilla () {
        const url = '/plantillas/Formato_Carga_Cambio_ECC_EAC.xlsx';
        window.location.href = url;
    },

    generar_cartas: function() {
      if (this.data.length < 1){
        this.crearNotificacion("Atención", "No existen datos para generar cartas. ", "error");
      }else{
        this.$Progress.start();
        this.cargafinalizada = false;

        var insert = "";
        var cont = 0;
        this.porinsertar = this.data.length / 30 == Math.trunc(this.data.length / 30) ? this.data.length / 30 : Math.trunc(this.data.length / 30) + 1;
        
        for (var i = 0; i < this.data.length; i++) {
          insert += this.data[i].poliza + ":";
          insert += this.data[i].ecc_nuevo + ":";
          insert += this.data[i].eac_nuevo + ":";
          insert += this.data[i].codigomotivo + ":";
          insert += this.data[i].correo_todas + ";";

          cont += 1;

          if (cont == 30 || i == this.data.length - 1) {
            cont = 0;
            apiMailCartas
              .generar_cartas(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                insert
              )
              .then(response => {
                this.porinsertar -= 1;
              })
              .catch(error => {
                this.$Progress.finish();
                this.crearNotificacion("Error de sistema", error, "error");
                return;
              });
            
            insert = "";
          }
        }
      }
    },


  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

    cargafinalizada: function(newCargafinalizada, oldCargafinalizada) {
      if (newCargafinalizada) {
        this.cargafinalizada = true;
        this.$Progress.finish();
      }
    },

    porinsertar: {
      handler(value, oldValue) {
        if (value == 0) {
          this.$Progress.finish();
          this.crearNotificacion("Información", "Cartas Generadas.", "success");
          this.pre_insertar();
        }
      },
      deep: true
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.card-header {
  background-color: #00a7d4;
  color: #fff;
}

.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}

.el-button {
  background: #00a7d4;
}
</style>
